const translation = {
  1: 'vs',
  3: 'vn',
  11: 'sd',
  15: 'tf',
  18: 'ds',
};

export default function siteIdToMucd(siteId) {
  if (typeof siteId !== 'number') {
    throw new Error('siteId must be a number');
  }
  return translation[siteId];
}
